import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

// Types derive from the backend OpenAPI contract (generated schema.d.ts).
export type SuppressionReason = Schemas['SuppressionReason'];
export type SuppressionDto = Schemas['SuppressionDto'];
export type SuppressionListResult = Schemas['SuppressionListResult'];

/** Client-side query parameters for the suppression list (not a response schema). */
export interface SuppressionFilter {
  reason?: SuppressionReason;
  emailContains?: string;
  skip?: number;
  take?: number;
}

export const suppression = {
  list: (filter: SuppressionFilter = {}) => {
    const params = new URLSearchParams();
    if (filter.reason) params.set('reason', filter.reason);
    if (filter.emailContains) params.set('email_contains', filter.emailContains);
    if (filter.skip != null) params.set('skip', String(filter.skip));
    if (filter.take != null) params.set('take', String(filter.take));
    const qs = params.toString();
    return request<SuppressionListResult>(`/v1/suppression/global${qs ? `?${qs}` : ''}`);
  },

  add: (email: string, reason?: string) =>
    request<SuppressionDto>('/v1/suppression/global', { method: 'POST', body: { email, reason } }),

  remove: (email: string) =>
    request<void>(`/v1/suppression/global/${encodeURIComponent(email)}`, { method: 'DELETE' }),
};
